document.addEventListener("DOMContentLoaded", function () {
	$(document).ready(function () {
		// Smooth scroll for anchor links
		$("a[href^='#']:not(.menu-item-text)").on("click", function (e) {
			e.preventDefault();

			var target = $(this.getAttribute("href"));

			$("html, body").animate({
				scrollTop: target.offset().top - 100
			}, 1000); // 1000ms = 1 second of animation
		});

		document.querySelectorAll('.wsi-current-year').forEach(n => n.textContent = new Date().getFullYear());
	});
});
